export default function FeaturedWork() {
  const works = [
    {
      image: 'https://readdy.ai/api/search-image?query=collection-of-handcrafted-wooden-pens-with-beautiful-grain-patterns-and-polished-finish-displayed-elegantly-on-natural-wood-surface-artisan-craftsmanship-warm-lighting-simple-clean-background&width=500&height=600&seq=work-pens-003&orientation=portrait',
      title: 'Custom Turned Pens',
      category: 'Hand Turned',
      description: 'Precision-crafted writing instruments'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=rustic-hand-painted-wooden-holiday-sign-with-festive-lettering-farmhouse-style-seasonal-decoration-hanging-on-weathered-wood-background-warm-colors-charming-design-simple-composition&width=500&height=400&seq=work-signs-003&orientation=landscape',
      title: 'Seasonal Signs',
      category: 'Hand Painted',
      description: 'Personalized wooden decor'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=handcrafted-wooden-spice-rack-with-multiple-compartments-beautiful-natural-wood-grain-mounted-on-kitchen-wall-artisan-furniture-warm-lighting-simple-clean-background&width=500&height=600&seq=work-spice-003&orientation=portrait',
      title: 'Spice Racks',
      category: 'Furniture',
      description: 'Functional kitchen art'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=elegant-wooden-cigar-holder-with-rich-wood-grain-and-polished-finish-displayed-on-natural-wood-surface-handcrafted-accessory-warm-ambient-lighting-simple-clean-background&width=500&height=400&seq=work-cigar-003&orientation=landscape',
      title: 'Cigar Holders',
      category: 'Hand Turned',
      description: 'Sophisticated accessories'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=beautiful-hand-painted-wooden-welcome-sign-with-artistic-lettering-rustic-farmhouse-decor-hanging-on-natural-wood-background-warm-inviting-colors-charming-design&width=500&height=600&seq=work-welcome-003&orientation=portrait',
      title: 'Welcome Signs',
      category: 'Hand Painted',
      description: 'Warm greetings for your home'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=handcrafted-wooden-cutting-board-with-beautiful-natural-grain-patterns-displayed-on-kitchen-counter-artisan-kitchenware-warm-lighting-simple-clean-background&width=500&height=400&seq=work-cutting-003&orientation=landscape',
      title: 'Cutting Boards',
      category: 'Kitchen',
      description: 'Durable and beautiful'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm uppercase tracking-[0.2em] text-amber-600 font-semibold mb-4 block">
            Portfolio
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Featured Creations
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A glimpse into our workshop - where passion meets craftsmanship
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {works.map((work, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-md hover:shadow-xl transition-all duration-500 cursor-pointer bg-gray-100"
            >
              <div className={`relative w-full overflow-hidden ${index % 3 === 1 ? 'h-72' : 'h-96'}`}>
                <img
                  src={work.image}
                  alt={work.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-300"></div>
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <span className="inline-block px-3 py-1 bg-amber-500/90 backdrop-blur-sm rounded-full text-xs font-semibold mb-2">
                  {work.category}
                </span>
                <h3 className="text-xl font-bold mb-1">{work.title}</h3>
                <p className="text-sm text-gray-200 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {work.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://www.etsy.com/shop/TelloCrafts"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-amber-500 text-white px-10 py-4 rounded-full text-base font-semibold hover:bg-amber-600 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-store-2-line mr-2 text-xl"></i>
            Shop on Etsy
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
